module.exports = __webpack_public_path__ + "f7ad53809690a1807fa696efb9a9ebfd.png";